"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');var c=()=>{let[e,t]=_react.useState.call(void 0, !1);return{active:e,toggle:()=>t(o=>!o)}};exports.useToggle = c;
